import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import Platform from "react-native-web/dist/exports/Platform";
import { coalesceExpirations, coalesceStatuses, coalesceCanAskAgain, coalesceGranted } from "./CoalescedPermissions";
import Permissions from "./ExpoPermissions";
import { PermissionStatus } from "./Permissions.types";
export { PermissionStatus };
export var CAMERA = 'camera';
export var CAMERA_ROLL = 'cameraRoll';
export var AUDIO_RECORDING = 'audioRecording';
export var LOCATION = 'location';
export var USER_FACING_NOTIFICATIONS = 'userFacingNotifications';
export var NOTIFICATIONS = 'notifications';
export var CONTACTS = 'contacts';
export var CALENDAR = 'calendar';
export var REMINDERS = 'reminders';
export var SYSTEM_BRIGHTNESS = 'systemBrightness';
export function getAsync() {
  var _len,
      types,
      _key,
      _args = arguments;

  return _regeneratorRuntime.async(function getAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
            types[_key] = _args[_key];
          }

          if (!(Platform.OS === 'ios')) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return _regeneratorRuntime.awrap(_handleMultiPermissionsRequestIOSAsync(types, Permissions.getAsync));

        case 4:
          return _context.abrupt("return", _context.sent);

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_handlePermissionsRequestAsync(types, Permissions.getAsync));

        case 7:
          return _context.abrupt("return", _context.sent);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function askAsync() {
  var _len2,
      types,
      _key2,
      _args2 = arguments;

  return _regeneratorRuntime.async(function askAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          for (_len2 = _args2.length, types = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            types[_key2] = _args2[_key2];
          }

          if (!(Platform.OS === 'ios')) {
            _context2.next = 5;
            break;
          }

          _context2.next = 4;
          return _regeneratorRuntime.awrap(_handleMultiPermissionsRequestIOSAsync(types, Permissions.askAsync));

        case 4:
          return _context2.abrupt("return", _context2.sent);

        case 5:
          _context2.next = 7;
          return _regeneratorRuntime.awrap(_handlePermissionsRequestAsync(types, Permissions.askAsync));

        case 7:
          return _context2.abrupt("return", _context2.sent);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, null, Promise);
}

function _handleSinglePermissionRequestIOSAsync(type, handlePermission) {
  return _regeneratorRuntime.async(function _handleSinglePermissionRequestIOSAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return _regeneratorRuntime.awrap(handlePermission(type));

        case 2:
          return _context3.abrupt("return", _context3.sent);

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, null, null, null, Promise);
}

function _handleMultiPermissionsRequestIOSAsync(types, handlePermission) {
  var permissions, _iterator, _step, type;

  return _regeneratorRuntime.async(function _handleMultiPermissionsRequestIOSAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (types.length) {
            _context4.next = 2;
            break;
          }

          throw new Error('At least one permission type must be specified');

        case 2:
          permissions = {};
          _iterator = _createForOfIteratorHelperLoose(types);

        case 4:
          if ((_step = _iterator()).done) {
            _context4.next = 11;
            break;
          }

          type = _step.value;
          _context4.next = 8;
          return _regeneratorRuntime.awrap(_handleSinglePermissionRequestIOSAsync(type, handlePermission));

        case 8:
          permissions[type] = _context4.sent;

        case 9:
          _context4.next = 4;
          break;

        case 11:
          return _context4.abrupt("return", {
            status: coalesceStatuses(permissions),
            expires: coalesceExpirations(permissions),
            canAskAgain: coalesceCanAskAgain(permissions),
            granted: coalesceGranted(permissions),
            permissions: permissions
          });

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, null, null, null, Promise);
}

function _handlePermissionsRequestAsync(types, handlePermissions) {
  var permissions;
  return _regeneratorRuntime.async(function _handlePermissionsRequestAsync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (types.length) {
            _context5.next = 2;
            break;
          }

          throw new Error('At least one permission type must be specified');

        case 2:
          _context5.next = 4;
          return _regeneratorRuntime.awrap(handlePermissions(types));

        case 4:
          permissions = _context5.sent;
          return _context5.abrupt("return", {
            status: coalesceStatuses(permissions),
            expires: coalesceExpirations(permissions),
            canAskAgain: coalesceCanAskAgain(permissions),
            granted: coalesceGranted(permissions),
            permissions: permissions
          });

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, null, null, null, Promise);
}